import React from "react";
import Accordions from "../components/Sidebar/Accordions/Accordions";
import SearchSection from "../components/Sidebar/SearchSection";
import SlidingPane from "react-sliding-pane";
import { useDispatch, useSelector } from "react-redux";
import {
  selectLicenseList,
  setModalStats,
  setSliderStatus,
} from "../api/redux";
import { Button } from "antd";
import { useMediaQuery } from "react-responsive";
import TileLayers from "../components/Sidebar/TileLayers";

export default () => {
  const state = useSelector(selectLicenseList);

  const dispatch = useDispatch();
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1000px)' })


  return (
    <aside className="sidebar d-none d-md-flex flex-column py-5">
      <SlidingPane
        isOpen={true}
        className={isTabletOrMobile ? "sliding-pane-mobile" : "sliding-pane"}
        overlayClassName={
          state.isSliderOpen
            ? "sliding-pane-overlay"
            : "sliding-pane-overlay-dnone"
        }
        closeIcon={
          <Button>
            <i className="fa fa-times"></i>
          </Button>
        }
        onRequestClose={() => {
          dispatch(setSliderStatus(false));
        }}
      >
        <SearchSection />
        <TileLayers />
        <Accordions />
      </SlidingPane>
    </aside>
  );
};
